import React, { Component, Fragment } from 'react';

import { Grid } from 'components/grid';
import { Loader } from 'components/loader';
import Pagination from 'components/pagination';
import { VALUES_PER_PAGE } from 'components/pagination/constants';
import { I18n, translate } from 'components/translate';
import { ImportService } from 'modules/userManager/imports';
import PropTypes from 'prop-types';

@translate()
export default class ImportHistoryDetail extends Component {
  static propTypes = {
    id: PropTypes.string,
    t: PropTypes.func,
    description: PropTypes.string
  };

  state = {
    content: [],
    totalElements: 0,
    page: 0,
    perPage: VALUES_PER_PAGE.TEN,
    numberOfElements: 0,
    sort: 'asc',
    loaded: false
  };

  get params() {
    const { sort, page, perPage: size } = this.state;

    return {
      sort: `user.name,${sort}`,
      page,
      size,
      requestId: this.props.id
    };
  }

  componentDidMount() {
    this.fetchHistoryDetail();
  }

  fetchHistoryDetail = async () => {
    this.setState({ loaded: false });

    const data = await ImportService.getImportHistoryDetail(this.params);

    this.setState({ ...data, loaded: true });
  };

  changeSort = () => {
    this.setState(
      (prevState) => {
        return prevState.sort === 'desc' ? { sort: 'asc' } : { sort: 'desc' };
      },
      () => {
        this.fetchHistoryDetail();
      }
    );
  };

  changePage = (page) => {
    this.setState({ page }, () => {
      this.fetchHistoryDetail();
    });
  };

  changePerPage = (perPage) => {
    this.setState({ perPage, page: 0 }, () => {
      this.fetchHistoryDetail();
    });
  };

  parseMessage = (message, parameter) => {
    const { t } = this.props;

    switch (message) {
      case 'pages.user_manager.invalid_email':
        return t('users_import.history.detail.messages.invalid_email');
      case 'pages.user_manager.invalid_email_detailed':
        return t(
          'users_import.history.detail.messages.invalid_email_detailed',
          { data: { detail: parameter || '' } }
        );
      case 'pages.user_manager.import.email_already_exists':
        return t('users_import.history.detail.messages.email_already_exists');
      case 'pages.user_manager.user_save_error_detailed':
        return t(
          'users_import.history.detail.messages.user_save_error_detailed',
          { data: { detail: parameter || '' } }
        );
      default:
        return '';
    }
  };

  renderHistoryInfo = () => {
    const { content, sort, page, totalElements, perPage } = this.state;

    return (
      <div>
        <label className="mb__lg">{this.props.description}</label>
        <table className="table">
          <thead>
            <tr>
              <th>
                <span
                  onClick={this.changeSort}
                  className={`arrow_${sort === '' ? 'sort' : sort}`}
                >
                  <I18n label="general.name" />
                </span>
              </th>
              <th>
                <I18n label="general.email" />
              </th>
              <th>
                <I18n label="general.class" />
              </th>
              <th>
                <I18n label="general.message" />
              </th>
              <th>
                <I18n label="general.status" />
              </th>
            </tr>
          </thead>
          <tbody>
            {content.map((item) => {
              return (
                <tr key={item.email}>
                  <td data-header={`${this.props.t('general.name')}:`}>
                    {item.name}
                  </td>
                  <td data-header={`${this.props.t('general.email')}:`}>
                    {item.email}
                  </td>
                  <td data-header={`${this.props.t('general.class')}:`}>
                    {item.class && (item.class.name || '-')}
                  </td>
                  <td data-header={`${this.props.t('general.message')}:`}>
                    {this.parseMessage(item.message, item.messageParameter)}
                  </td>
                  <td data-header={`${this.props.t('general.status')}:`}>
                    {
                      <i
                        className={`icon icon-${
                          item.status.toLowerCase() === 'success'
                            ? 'check'
                            : 'close'
                        }
                        icon-rounded icon-${item.status.toLowerCase()}`}
                      />
                    }
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <Pagination
          className="mt__md mb__sm"
          totalRegisters={totalElements}
          currentPage={page}
          changePage={this.changePage}
          changePerPage={this.changePerPage}
          perPage={perPage}
        />
      </div>
    );
  };

  renderEmptyInfo = () => {
    return (
      <Fragment>
        <label className="mb__lg">{this.props.description}</label>
        <Grid block>
          <div className="empty__history">
            <div className="empty__list__icon">
              <i className="icon icon-empty" />
            </div>
            <div className="empty__history__description">
              <I18n label="users_import.history.detail.empty" />
            </div>
          </div>
        </Grid>
      </Fragment>
    );
  };

  render() {
    const { loaded, content } = this.state;

    if (loaded) {
      return content.length ? this.renderHistoryInfo() : this.renderEmptyInfo();
    }

    return <Loader key="loader" mask />;
  }
}
